export default __webpack_public_path__ + "static/media/professional-camera-blurred_169016-10249.4316050b.jpg";